/**
 * The possible directions the menu of the {@link DropdownComponent} can pop out of the button.
 *
 * @private
 */
export class DropdownMenuDirection {
  /**
   * The menu will pop out above the button.
   */
  static readonly UP: [ number, number ] = [ 0, -1 ]
  /**
   * The menu will pop out below the button.
   */
  static readonly DOWN: [ number, number ] = [ 0, 1 ]
  /**
   * The menu will pop out to the left of the button.
   */
  static readonly LEFT: [ number, number ] = [ -1, 0 ]
  /**
   * The menu will pop out to the right of the button.
   */
  static readonly RIGHT: [ number, number ] = [ 1, 0 ]

  private static readonly VALID_STRINGS = [ 'UP', 'DOWN', 'LEFT', 'RIGHT' ]

  static fromString(value: string): [ number, number ] {
    let updatedKey = value.toUpperCase()
    if (this.VALID_STRINGS.includes(updatedKey)) {
      return this[updatedKey]
    }

    throw new Error(`No direction found for with the name "${ value }" in DropdownMenuDirection.`)
  }
}
